import React, { useState } from "react";
import { Check, Download } from "lucide-react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";import { useStore } from "../../helpers";
import { downloadEnquiryResume } from "./enquiry-resume-download";
import {
    getEnquiryId,
    getResumeLabel,
    getResumePath,
    hasEnquiryResume,
    type EnquiryRow,
} from "./enquiry-helpers";

type EnquiryResumeDownloadButtonProps = {
    row: EnquiryRow;
};

export const EnquiryResumeDownloadButton = ({ row }: EnquiryResumeDownloadButtonProps) => {
    const rootStore = useStore();
    const [loading, setLoading] = useState(false);
    const [downloaded, setDownloaded] = useState(false);
    const resumePath = getResumePath(row);
    const enquiryId = getEnquiryId(row);

    if (!hasEnquiryResume(row) || enquiryId == null || !rootStore.api) {
        return <span>-</span>;
    }

    const handleDownload = async () => {
        if (!rootStore.api || enquiryId == null) return;
        setLoading(true);
        try {
            await downloadEnquiryResume(rootStore.api, enquiryId, getResumeLabel(resumePath));
            setDownloaded(true);
        } catch {
            toast.error("Could not download resume. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
            <span className="break-all text-sm font-medium text-gray-800">
                {getResumeLabel(resumePath)}
            </span>
            <Button
                variant="outlined"
                size="small"
                startIcon={
                    downloaded ? (
                        <Check className="h-4 w-4" />
                    ) : (
                        <Download className="h-4 w-4" />
                    )
                }
                onClick={handleDownload}
                disabled={loading || downloaded}
                sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    alignSelf: "flex-start",
                    ...(downloaded
                        ? {
                              borderColor: "#10B981",
                              color: "#059669",
                              backgroundColor: "#ECFDF5",
                          }
                        : {}),
                }}
            >
                {loading ? "Downloading..." : downloaded ? "Downloaded" : "Download"}
            </Button>
        </div>
    );
};
